
import { mapGetters } from 'vuex'
import { convertToSlug } from '~/helpers/generate-slug'
export default {
  computed: {
    ...mapGetters({
      getCategories: 'categories/getCategories',
    }),
  },
  props: {
    product: {
      default: () => {
        return {
          imagePath: '',
        }
      },
    },
  },
  methods: {
    convertToSlug,
  },
}
